import { publicPath } from "Constants/constants";
import { useEffect, useState } from "react";
import { useBreadcrumbs } from "Store/texts/hooks";
import { getRootUri } from "./breadcrumb.helpers";
import { Crumb } from "./breadcrumb.types";

interface Pathname {
  readonly pathname: string;
  readonly origin: string;
}

export function usePathname(): Pathname {
  const { pathname, origin } = window.location;
  return { pathname, origin };
}

export const useSetBreadcrumbs = (): Crumb[] => {
  const [crumbs, setCrumbs] = useState<Array<Crumb>>([]);
  const { pathname, origin } = usePathname();
  const [urlMap, lang] = useBreadcrumbs();
  useEffect(() => {
    const parts = pathname
      .split("/")
      .map((cur, index, arr) => {
        if (!urlMap.hasOwnProperty(cur)) {
          return null;
        }

        return {
          title: urlMap[cur][lang],
          href: `${origin}${
            cur === publicPath
              ? getRootUri()
              : arr.slice(0, index + 1).join("/")
          }`,
        };
      })
      .filter((crumb): crumb is Crumb => crumb !== null);

    setCrumbs(parts);
  }, [pathname, setCrumbs]);

  return crumbs;
};
